import axios from 'axios'

export const getContentPage = (url) =>
    axios.get(`content/${url}`)
        .then(({ data }) => data)
